import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BrandData } from '../shared/brand-data';
import { BestService } from './best.service';
import { Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  data: BrandData;

  constructor(private route: ActivatedRoute, private best: BestService) {
    this.data = new BrandData;

    const prettyDomains = {
      'best10refinance.com': 'Best10Refinance',
      'thetop10mortgage.com': 'TheTop10Mortgage',
      'thetop10refinance.com': 'TheTop10Refinance',
      'top10bestlenders.com': 'Top10BestLenders',
      'mortgagehomeequity.com': 'MortgageHomeEquity',
    };

    // Get the domain without subdomain
    let splitDomain = window.location.hostname.toString().split('.');
    let brand = this.route.snapshot.queryParams['brand'];
    let pthBrand = this.route.snapshot.queryParams['utm_medium'] === 'pathtohome' || window.location.hostname.includes('pathtohome');
    splitDomain.shift();
    this.data.domain = splitDomain.join('.');

    switch (this.data.domain) {
      case 'searchmortgagerate.com':
        this.data.view = 'mm';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-mm.js';
        this.data.logoSrc = '/assets/images/searchmortgagerate-logo-new.png';
        break;

      case 'houseequityoptions.com':
        this.data.pageType = 'home-equity-loan';
        this.data.view = 'mm';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-mm.js';
        this.data.logoSrc = '/assets/images/houseequityoptions.png';
        break;

      case 'homeequityoptions.com':
        this.data.pageType = 'home-equity-options';
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-fru.js';
        this.data.logoSrc = '/assets/images/homeequityoptions.png';
        break;
        
      case 'homemortgagecalc.com':
        this.data.pageType = 'calculator';
        this.data.view = 'mm';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-mm.js';
        this.data.logoSrc = '/assets/images/homemortgagecalc.png';
        break;

      case 'harp-2.org':
        this.data.pageType = 'harp';
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-harp.js';
        this.data.logoSrc = '/assets/images/logo.png';
        break;

      case 'homeequitychoice.com':
        this.data.pageType = 'home-equity-loan';
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-fru.js';
        this.data.logoSrc = '/assets/images/homeequitychoice.png';
        break;

      case 'homeequitycalculate.com':
        this.data.pageType = 'equity-calculator';
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-fru.js';
        this.data.logoSrc = '/assets/images/homeequitycalculate.png';
        break;

      case 'vamortgageratesonline.com':
        this.data.pageType = 'va';
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-fru.js';
        this.data.logoSrc = '/assets/images/vamortgageratesonline.png';
        break;

      case 'best10refinance.com':
      case 'thetop10mortgage.com':
      case 'thetop10refinance.com':
      case 'top10bestlenders.com':
      case 'mortgagehomeequity.com':
        // let d = this.data.domain.split('.');

        this.data.view = 'best';
        this.data.prettyDomain = prettyDomains[this.data.domain] || 'FreerateUpdate';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-best.js';
        this.best.lenderSubscribe.subscribe((clientId) => {
          this.data.logoSrc = (clientId === '')
          ? '/assets/images/logo.png'
          : `https://s3-us-west-2.amazonaws.com/fru-client-logos/production/300x100/${clientId}.png`;

          this.data.logoWasabiSrc = this.data.logoSrc.replace('s3-us-west-2.amazonaws.com', 's3.us-central-1.wasabisys.com');
        });
        this.data.abLogoSrc = '/images/' + this.data.domain.replace('.com', '.png');
        this.data.tyLogoSrc = '/images/' + this.data.domain.replace('.com', '.png');
        break;

      case 'bestmortgagelenders.com':
      case 'shopmortgagelenders.com':
        // let d = this.data.domain.split('.');

        this.data.view = 'best';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-best.js';
        this.best.lenderSubscribe.subscribe((clientId) => {
          this.data.logoSrc = (clientId === '')
          ? '/assets/images/' + this.data.domain.replace('.com', '.webp')
          : `https://s3-us-west-2.amazonaws.com/fru-client-logos/production/300x100/${clientId}.png`;

          this.data.logoWasabiSrc = this.data.logoSrc.replace('s3-us-west-2.amazonaws.com', 's3.us-central-1.wasabisys.com');
        });
        this.data.abLogoSrc = '/assets/images/' + this.data.domain.replace('.com', '.webp');
        this.data.tyLogoSrc = '/assets/images/' + this.data.domain.replace('.com', '.webp');
        break;
      
      case 'besthomeequityloan.com':
        this.data.pageType = 'home-equity-loan';
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-bhel.js';
        this.data.logoSrc = '/assets/images/besthomeequityloan.png';
        break;

      default:
        this.data.view = 'fru';
        this.data.trackingSrc = '/assets/scripts/form-landing-tracking-fru.js';
        this.data.logoSrc = '/assets/images/fru-logo.svg';
        break;
    }

    if (pthBrand) {
      this.data.view = 'best';
      this.data.trackingSrc = 'assets/scripts/form-landing-tracking-pth.js';
      this.data.logoSrc = 'assets/images/pathtohome.png';
    }

    if (brand === 'best') {
      this.data.view = 'best';

      if (this.data.abLogoSrc == '') {
        this.data.abLogoSrc = this.data.logoSrc;
      }

      this.best.lenderSubscribe.subscribe((clientId) => {
        this.data.logoSrc = (clientId === '')
        ? '/assets/images/logo.png'
        : `https://s3-us-west-2.amazonaws.com/fru-client-logos/production/300x100/${clientId}.png`;

        this.data.logoWasabiSrc = this.data.logoSrc.replace('s3-us-west-2.amazonaws.com', 's3.us-central-1.wasabisys.com');
      });
    }
  }

  updateMetaDescription(meta: Meta): void {
    const prettyDomain = this.data.prettyDomain || 'FreerateUpdate';
    const currentDescription = meta.getTag('name=description')?.content || '';
    const regex = new RegExp(` from ${prettyDomain}.`, 'g');
    const cleanDescription = currentDescription.replace(regex, '');
    const description = `${cleanDescription} from ${prettyDomain}.`;
    meta.updateTag({ name: 'description', content: description });
  }

  get isTop10(): boolean {
    return this.data.domain.includes('top10') || this.data.domain.includes('mortgagehomeequity') || this.data.domain.includes('bestmortgagelenders') || this.data.domain.includes('shopmortgagelenders');
  }

  get pageType(): string {
    return this.data.pageType;
  }

  set pageType(pt: string) {
    this.data.pageType = pt;
  }

  get view(): string {
    return this.data.view;
  }

  set view(v: string) {
    this.data.view = v;
  }

  get trackingSrc(): string {
    return this.data.trackingSrc;
  }

  set trackingSrc(ts: string) {
    this.data.trackingSrc = ts;
  }

  get abLogoSrc(): string {
    return this.data.abLogoSrc;
  }

  set abLogoSrc(ls: string) {
    this.data.abLogoSrc = ls;
  }

  get logoSrc(): string {
    return this.data.logoSrc;
  }

  set logoSrc(ls: string) {
    this.data.logoSrc = ls;
  }

  get tyLogoSrc(): string {
    return this.data.tyLogoSrc;
  }

  get logoWasabiSrc(): string {
    return this.data.logoWasabiSrc;
  }

  get domain(): string {
    return this.data.domain;
  }

  set domain(d: string) {
    this.data.domain = d;
  }
}
